<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  created () {
    let that = this
    // 本地存储的user存在
    if (that.getLocalObj('xianggangzhongxie').token) {
      // console.log('token 存在')
      // 如果时间过期 则返回初始化
      if (new Date().getTime() - that.getLocalObj('xianggangzhongxie').token_time >= 3600 * 2 * 1000) {
        // console.log('时间戳过期')
        that.$store.commit('updateAll', {token: '', token_time: '', user_id: '', userType: '', isRuHui: '', hasQiYe: '', isShenHe: '', userName: '', })
      } else {
        // 把本地存储的数据导入全局仓库
        that.$store.commit('updateUser', {
          user_id: that.getLocalObj('xianggangzhongxie').user_id,
          token: that.getLocalObj('xianggangzhongxie').token,
          token_time: that.getLocalObj('xianggangzhongxie').token_time,
          userName: that.getLocalObj('xianggangzhongxie').userName,
        })

        that.$store.commit('updateUserType', {
          userType: that.getLocalObj('xianggangzhongxie').userType,
        })
        that.$store.commit('updateIsShenHe', {
          isShenHe: that.getLocalObj('xianggangzhongxie').isShenHe,
        })
        that.$store.commit('updateIsRuHui', {
          isRuHui: that.getLocalObj('xianggangzhongxie').isRuHui,
        })
        that.$store.commit('updateHasQiYe', {
          hasQiYe: that.getLocalObj('xianggangzhongxie').hasQiYe,
        })
        // console.log('时间戳没有过期')
        // console.log(that.getLocalObj('xianggangzhongxie'))
        // console.log(that.$store.state.hasQiYe)
        // console.log(that.$store.state.isRuHui)
        // console.log(that.$store.state.isShenHe)
        // console.log(that.$store.state.token)
        // console.log(that.$store.state.token_time)
        // console.log(that.$store.state.userName)
        // console.log(that.$store.state.userType)
        // console.log(that.$store.state.user_id)
      }
    } else {
      // 不存在user 返回初始化
      that.$store.commit('updateAll', {token: '', token_time: '', user_id: '', userType: '', isRuHui: '', hasQiYe: '', isShenHe: '', userName: '', })
    }
  },
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: rgb(232, 232, 232);
}

.top-box {
  width: 1200px;
  margin: 0 auto;
}

.banner-box {
  width: 100%;
}
.banner-box-logo {
  left: 0;
  top: 0;
}
img {
  vertical-align: bottom;
}

.swiper-img {
  height: 300px;
}

.input-style {
  display: inline-block;
  height: 28px;
  outline: none;
}

.slideDown-enter-active {
  transition: all .5s ease;
  height: 255px;
  overflow: hidden;
}
.slideDown-leave-active{
  transition: all .5s ease;
  height: 0;
  overflow: hidden;
}
.slideDown-enter {
  height: 0;
  overflow: hidden;
}
.slideDown-leave {
  height: 255px;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/App.vue